import Vue from 'vue';

import {
    SET_VISITORS_ANALYTICS,
    SET_TURNOVER_ANALYTICS,
    SET_ADAPTATIONS_ANALYTICS,
    SET_DEMOGRAPHY_ANALYTICS,
    SET_POSITIONS_ANALYTICS,
    SET_COINS_ANALYTICS,
    SET_MODULES_ANALYTICS
} from './mutations.type'

const fetchAnalytics = async (context: any, endpoint: string, mutation: any) => {
    const response = await Vue.axios.get(`api/analytics/${endpoint}`);
    context.commit(mutation, response.data);
    return response.data;
};

export const getVisitorsAnalytics = async (context: any, client_id: string) =>
    fetchAnalytics(context, `visitors/${client_id}`, SET_VISITORS_ANALYTICS);

export const getTurnoverAnalytics = (context: any, client_id: string) =>
    fetchAnalytics(context, `turnover/${client_id}`, SET_TURNOVER_ANALYTICS);

export const getAdaptationsAnalytics = (context: any, client_id: string) =>
    fetchAnalytics(context, `adaptations/${client_id}`, SET_ADAPTATIONS_ANALYTICS);

export const getDemographyAnalytics = (context: any, client_id: string) =>
    fetchAnalytics(context, `demography/${client_id}`, SET_DEMOGRAPHY_ANALYTICS);

export const getPositionsAnalytics = (context: any, client_id: string) =>
    fetchAnalytics(context, `positions/${client_id}`, SET_POSITIONS_ANALYTICS);

export const getCoinsAnalytics = async (context: any, params: { client_id: string, dateFrom?: string, dateTo?: string }) => {
    const queryParams = new URLSearchParams();
    const { client_id, dateFrom, dateTo } = params;
    if (dateFrom) queryParams.append('dateFrom', dateFrom);
    if (dateTo) queryParams.append('dateTo', dateTo);
    const queryString = queryParams.toString();
    const endpoint = 'coins/' + client_id + (queryString ? '?' + queryString : '');
    return fetchAnalytics(context, endpoint, SET_COINS_ANALYTICS);
}

export const reportSession = async (context: any, sessionData: { sessionStart: string; currentTime: string; userId: string, clientId: string }) => {
    await Vue.axios.post('api/analytics/visitors', sessionData);
}

export const reportModuleVisit = async (context: any, moduleData: { moduleName: string; date: string, userId: string; clientId: string }) => {
    await Vue.axios.post('api/analytics/modules', moduleData);
}

export const getModuleAnalytics = async (context: any, client_id: string) => {
    fetchAnalytics(context, `modules/${client_id}`, SET_MODULES_ANALYTICS);
}